var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPrivateActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPrivateActive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 6,
    width: 12,
    height: 8,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open-image4",
    transform: "translate(-198.000000, -42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(9.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(89.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(29.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(11.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPrivateActive",
    transform: "translate(61.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3109325,12.7396229 C11.3109325,13.5249029 10.6791361,14.1639133 9.90272141,14.1639133 L1.94682693,14.1639133 C1.17041221,14.1639133 0.538615834,13.5249029 0.538615834,12.7396229 L0.538615834,7.41671529 C0.538615834,6.63143526 1.17041221,5.99242486 1.94682693,5.99242486 L9.90272141,5.99242486 C10.6791361,5.99242486 11.3109325,6.63143526 11.3109325,7.41671529 L11.3109325,12.7396229 Z M2.15446333,3.94955275 C2.15446333,2.07201709 3.84571705,0.544765896 5.92477417,0.544765896 C8.00383129,0.544765896 9.69508501,2.07201709 9.69508501,3.94955275 L9.69508501,5.44765896 L2.15446333,5.44765896 L2.15446333,3.94955275 Z M10.2337008,3.94955275 C10.2337008,1.77185108 8.30060861,0 5.92477417,0 C3.54893973,0 1.6158475,1.77185108 1.6158475,3.94955275 L1.6158475,5.47843824 C0.699931276,5.63805464 0,6.4453977 0,7.41698768 L0,12.7398953 C0,13.8253413 0.873365574,14.7086792 1.94682693,14.7086792 L10.2337008,14.7086792 C11.3071622,14.7086792 11.8495483,13.8253413 11.8495483,12.7396229 L11.8495483,7.41671529 C11.8495483,6.4453977 11.1496171,5.63805464 10.2337008,5.47843824 L10.2337008,3.94955275 Z",
    id: "Fill-1",
    stroke: "#FFFFFF",
    strokeWidth: 0.3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-13"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 1,
    x: 0.5,
    y: 6.5,
    width: 11,
    height: 7,
    rx: 2
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrivateActive);
export default __webpack_public_path__ + "static/media/icPrivateActive.ff8390ebefdc1da7b8c0fd7d6dfd8501.svg";
export { ForwardRef as ReactComponent };